import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { ImageZoomPage } from './image-zoom.page';
import { PinchZoomModule } from 'ngx-pinch-zoom';
import { TranslateModule } from '@ngx-translate/core';
import { Camera } from '@ionic-native/camera/ngx';

const routes: Routes = [
  {
    path: '',
    component: ImageZoomPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes),
    PinchZoomModule,
    TranslateModule.forChild(),
  ],
  declarations: [ImageZoomPage],
  providers: [Camera]
})
export class ImageZoomPageModule { }
